// extracted by mini-css-extract-plugin
export default {"selectMobile":"xdF0ub"};